import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listSpecs } from '@/api/product.js';
import { listBrand } from '@/api/brand.js';
import { findDealerUserManu } from '@/api/manufacturer.js';
export default {
  components: {},
  data: function data() {
    return {
      drawerTitle: '添加产品',
      drawerVisible: false,
      searchForm: {
        barCode: null,
        manufacturerId4: null,
        productNumber: null,
        productName: null,
        specificationModel: null,
        brandId: null,
        page: 1,
        pageSize: 10,
        total: 0
      },
      brandList: [],
      brandLoading: false,
      dataList: [],
      dataLoading: false,
      searchFormExpand: false,
      isDisplayPrice: 2,
      consignmentPriceShow: false
    };
  },
  methods: {
    init: function init(_ref) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var distributorId, barCode, consignmentPriceShow, that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                distributorId = _ref.distributorId, barCode = _ref.barCode, consignmentPriceShow = _ref.consignmentPriceShow;
                that = _this;
                that.drawerVisible = true;
                that.searchForm.barCode = barCode;
                that.searchForm.manufacturerId4 = distributorId;
                that.consignmentPriceShow = consignmentPriceShow;
                that.searchForm.page = 1;
                that.dataList = [];
                _context.next = 10;
                return that.loadDealerUserManu();

              case 10:
                _context.next = 12;
                return that.loadBrand();

              case 12:
                _context.next = 14;
                return that.loadData();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadDealerUserManu: function loadDealerUserManu() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2;
                _context2.next = 3;
                return findDealerUserManu({
                  manuId: that.searchForm.manufacturerId4
                }).then(function (res) {
                  that.isDisplayPrice = res.redealerUser.isDisplayPrice || 2;
                }).catch(function (e) {
                  console.log(e.message);
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    drawerClose: function drawerClose() {
      var that = this;
      that.$nextTick(function () {
        that.drawerVisible = false;
      });
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this3;
                query = JSON.parse(JSON.stringify(that.searchForm));
                that.dataLoading = true;
                that.dataList = [];
                _context3.next = 6;
                return listSpecs(query).then(function (res) {
                  res.list.map(function (row) {
                    row.specs = row.specs ? row.specs : {};
                    that.dataList.push({
                      ID: null,
                      specsId: row.ID,
                      mainId: row.mainId,
                      sellQuantity: 0,
                      sellUnitPrice: row.sellUnitPrice,
                      sellAmount: 0,
                      remarks: null,
                      productName: row.main.productName,
                      brandName: row.main.brandName,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      genericName: row.genericName,
                      productNumber: row.productNumber || null,
                      barCode: row.barCode || null,
                      specificationModel: row.specificationModel || null,
                      unit: row.unit || null,
                      wholesalePurchasePrice: row.wholesalePurchasePrice || 0,
                      consignmentPurchasePrice: row.consignmentPurchasePrice || 0,
                      marketPrice: row.marketPrice || 0,
                      consignmentPrice: row.consignmentPrice || 0,
                      wholesalePrice: row.wholesalePrice || 0,
                      onlPrice: row.onlPrice || 0,
                      lowPrice: row.lowPrice || 0,
                      checked: false
                    });
                  });
                  that.searchForm.total = res.total;
                }).catch(function (e) {
                  console.log(e);
                });

              case 6:
                that.dataLoading = false;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    loadBrand: function loadBrand() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.brandList = [];
                that.brandLoading = true;
                query = {
                  page: 1,
                  pageSize: 9999
                };
                _context4.next = 6;
                return listBrand(query).then(function (res) {
                  that.brandList = res.list;
                }).catch(function (e) {});

              case 6:
                that.brandLoading = false;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    formSubmit: function formSubmit() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, rows, findRow;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                rows = that.$refs.productTableRef.selection;

                if (!(rows.length === 0)) {
                  _context5.next = 5;
                  break;
                }

                that.$message.error('请选择产品');
                return _context5.abrupt("return");

              case 5:
                rows.map(function (item) {
                  item.sellUnitPrice = Number(item.consignmentPrice);
                  item.sellAmount = Number(Number(item.consignmentPrice) * Number(item.sellQuantity)).toFixed(2);
                  item.sellAmount = Number(item.sellAmount);
                });
                findRow = rows.find(function (item) {
                  return item.sellQuantity === 0;
                });

                if (!findRow) {
                  _context5.next = 11;
                  break;
                }

                that.$message.error('产品：' + findRow.productName + ' 规格型号：' + findRow.specificationModel + '，未设置采购数量');
                that.$refs.productTableRef.setCurrentRow(findRow, true);
                return _context5.abrupt("return");

              case 11:
                that.$emit('add', rows);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    rowClick: function rowClick(row) {
      var that = this;
      that.$refs.productTableRef.toggleRowSelection(row); // 判断该行记录，是选中还是未选中

      var rows = that.$refs.productTableRef.selection;

      if (rows.includes(row)) {
        if (row.sellQuantity < 1) {
          row.sellQuantity = 1;
        }
      }
    },
    rowClassName: function rowClassName(_ref2) {
      var row = _ref2.row;
      var that = this;
      var rows = that.$refs.productTableRef.selection;

      if (rows.includes(row)) {
        row.checked = true;
      } else {
        row.checked = false;
      }
    },
    selectionChange: function selectionChange(selection) {
      selection.map(function (item) {
        item.sellQuantity = item.sellQuantity || 1;
      });
    }
  }
};